// extracted by mini-css-extract-plugin
export default {"About":"About_About__g0Mpo","topFlex":"About_topFlex__KmNQ6","topFlex__left":"About_topFlex__left__+qif4","rulesCorp":"About_rulesCorp__oam7W","licenze":"About_licenze__E3VBH"};